import { COUNTRIES } from '@internations/ds'

/**
 * ISO 3166-1 alpha-2 standard codes for countries (not languages)
 *
 * @see https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 */
const ISO_COUNTRY_CODES = COUNTRIES.map(({ iso31661alpha2code }) => iso31661alpha2code)

export default ISO_COUNTRY_CODES
